export default __webpack_public_path__ + "images/219d232c9eb1a8714187e076476aab68-mormonism.webp";